

























































































































































































import {
  Component,
  Vue,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import bContainer from 'bootstrap-vue/es/components/layout/container';
import bForm from 'bootstrap-vue/es/components/form/form';
import bFormInput from 'bootstrap-vue/es/components/form-input/form-input';
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select';
import bImg from 'bootstrap-vue/es/components/image/img';
import bLink from 'bootstrap-vue/es/components/link/link';

import AvailabilityBlock from '@/components/AvailabilityBlock.vue';
import PriceBlock from '@/components/PriceBlock.vue';
import PrimaryButton from '@/components/PrimaryButton.vue';

import CartView from './CartView';
import EmptyCartView from './EmptyCartView.vue';

@Component({
  components: {
    bContainer,
    bForm,
    bFormInput,
    bFormSelect,
    bImg,
    bLink,

    AvailabilityBlock,
    EmptyCartView,
    PriceBlock,
    PrimaryButton,
  },
})
export default class DesktopCartView extends mixins(CartView) { }

